export enum WebHookType {
  LABEL_CHANGED = 'labelChanged',
  CONVERSATION_CASE = 'conversationCaseWebhook',
  FORWARD_MESSAGE = 'forwardMessagesWebhook',
  FORWARD_MESSAGES_BUTTONS = 'forwardMessagesButtonsWebhook',
  SEND_TASK = 'sendTaskWebHook',
  SET_READ = 'setReadWebhook',
  SET_UNREAD = 'setUnreadWebhook',
}

type WebHook = {
  WebhookIdentifier: WebHookType;
  WebhookUrl: string;
};

export type { WebHook };
